import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private renderer: Renderer2;
    private darkThemeClass = 'dark-theme';

    constructor(private rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    enableDarkTheme() {
        this.renderer.addClass(document.body, this.darkThemeClass);
    }

    enableLightTheme() {
        this.renderer.removeClass(document.body, this.darkThemeClass);
    }

    toggleTheme(isDark: boolean) {
        if (isDark) {
            this.enableDarkTheme();
        } else {
            this.enableLightTheme();
        }
    }
}
